<template>
	<div class="flow-clock-container">
		{{ currentTime }}
	</div>
</template>
<script lang="ts">
import { defineComponent } from "vue";

function getCurrentTime() {
	return new Date().toLocaleTimeString("en", { hour12: true });
}

export default defineComponent({
	name: "Clock",

	data: () => ({
		currentTime: getCurrentTime() as string
	}),

	mounted() {
		setInterval(() => {
			this.currentTime = getCurrentTime();
		}, 1000);
	}
});
</script>
<style lang="scss">
div.flow-clock-container {
	color: var(--dashboard-font-dark);
	font-size: 16px;
	line-height: 16px;
	font-weight: normal;
	font-family: monospace;
	flex-shrink: 0;
	white-space: nowrap;
}
</style>
